module.exports = __webpack_public_path__ + "static/img/01.89227e4a.png";